













import { Component, Mixins, Prop } from "vue-property-decorator";
import { TextBoxInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import { DisableableMixin } from "../../../system/mixins";
import TextBoxWrapperObject from "../../../document/editor/objects/TextBoxWrapperObject.vue";
import TextBoxInputMethodSelector from "./TextBoxInputMethodSelector.vue";
import InputMethodEditCheckBox from "./InputMethodEditCheckBox.vue";

@Component({
  components: {
    TextBoxInputMethodSelector,
    InputMethodEditCheckBox,
  }
})
export default class TextBoxInputMethodEditor extends Mixins(DisableableMixin) {
  @Prop()
  source: TextBoxWrapperObject;

  get selected(): TextBoxInputMethodKinds {
    return this.source.inputMethodKind;
  }

  set selected(value: TextBoxInputMethodKinds) {
    this.source.inputMethodKind = value;
  }
}
